export const filterItemAction = (filter) => {
    return{
        type: 'changeFilterItem',
        filter: filter
    }
}